{
  "dashboard": {
    "title": "Admin Dashboard",
    "welcome": "Welcome to the administration panel",
    "description": "Manage the platform content and settings from here.",
    "placeholder": "Dashboard content will be implemented here."
  },
  "navigation": {
    "general": "General",
    "external": "External",
    "dashboard": "Dashboard",
    "recommendations": "Recommendations",
    "evaluations": "Evaluations",
    "medias": "Medias",
    "agents": "Agents",
    "users": "Users",
    "institutions": "Institutions",
    "subscriptions": "Subscriptions",
    "sensoquizz": "SensoQuizz",
    "mobileApp": "Mobile App",
    "changelog": "Changelog",
    "logoAlt": "MetaDevProfile logo",
    "brandName": "MetaDevProfile",
    "roles": {
      "admin": "Administrator"
    }
  },
  "users": {
    "title": "User Management",
    "description": "Manage practitioner users and their profiles",
    "form": {
      "basic": "Basic Information",
      "profile": "Profile Details",
      "settings": "Account Settings",
      "firstName": "First Name",
      "firstNamePlaceholder": "Enter first name",
      "lastName": "Last Name",
      "lastNamePlaceholder": "Enter last name",
      "email": "Email Address",
      "emailPlaceholder": "Enter email address",
      "phone": "Phone Number",
      "phonePlaceholder": "Enter phone number",
      "password": "Password",
      "passwordPlaceholder": "Enter password",
      "generatePassword": "Generate Password",
      "showPassword": "Show Password",
      "hidePassword": "Hide Password",
      "gender": "Gender",
      "genderPlaceholder": "Select gender",
      "language": "Language",
      "languagePlaceholder": "Select language",
      "theme": "Theme",
      "themePlaceholder": "Select theme",
      "platform": "Platform",
      "platformPlaceholder": "Select platform",
      "pushEnabled": "Push Notifications",
      "pushEnabledDescription": "Enable push notifications for this user"
    },
    "table": {
      "search": "Search users...",
      "filter": {
        "all": "All Users",
        "active": "Active",
        "archived": "Archived",
        "allTypes": "All types"
      },
      "columns": {
        "user": "User",
        "email": "Email",
        "type": "Type",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "type": {
        "practitioner": "Practitioner",
        "institution": "Institution"
      },
      "status": {
        "active": "Active",
        "archived": "Archived",
        "noProfile": "No Profile"
      },
      "actions": {
        "edit": "Edit User",
        "archive": "Archive User",
        "activate": "Activate User",
        "view": "View Details",
        "impersonate": "View as"
      },
      "empty": {
        "title": "No users found",
        "description": "No users match your current search criteria."
      },
      "pagination": {
        "previous": "Previous",
        "next": "Next",
        "page": "Page {{current}} of {{total}}",
        "showing": "Showing {{from}} to {{to}} of {{total}} users"
      }
    },
    "create": {
      "title": "Create New User",
      "description": "Add a new practitioner user to the system",
      "button": "Add User",
      "form": {
        "basic": "Basic Information",
        "profile": "Profile Details",
        "settings": "Account Settings",
        "firstName": "First Name",
        "firstNamePlaceholder": "Enter first name",
        "lastName": "Last Name",
        "lastNamePlaceholder": "Enter last name",
        "email": "Email Address",
        "emailPlaceholder": "Enter email address",
        "phone": "Phone Number",
        "phonePlaceholder": "Enter phone number",
        "password": "Password",
        "passwordPlaceholder": "Enter password",
        "generatePassword": "Generate Password",
        "showPassword": "Show Password",
        "hidePassword": "Hide Password",
        "gender": "Gender",
        "genderPlaceholder": "Select gender",
        "language": "Language",
        "languagePlaceholder": "Select language",
        "theme": "Theme",
        "themePlaceholder": "Select theme",
        "platform": "Platform",
        "platformPlaceholder": "Select platform",
        "pushEnabled": "Push Notifications",
        "pushEnabledDescription": "Enable push notifications for this user"
      },
      "validation": {
        "firstNameRequired": "First name is required",
        "lastNameRequired": "Last name is required",
        "emailRequired": "Email is required",
        "emailInvalid": "Please enter a valid email address",
        "passwordRequired": "Password is required",
        "passwordMinLength": "Password must be at least 8 characters"
      },
      "actions": {
        "cancel": "Cancel",
        "create": "Create User"
      }
    },
    "edit": {
      "title": "Edit User",
      "description": "Update user information and profile details",
      "form": {
        "basic": "Basic Information",
        "profile": "Profile Details",
        "settings": "Account Settings"
      },
      "actions": {
        "cancel": "Cancel",
        "save": "Save Changes"
      }
    },
    "archive": {
      "title": "Archive User",
      "description": "Are you sure you want to archive this user? They will no longer be able to access the system.",
      "userName": "User: {{name}}",
      "userEmail": "Email: {{email}}",
      "actions": {
        "cancel": "Cancel",
        "archive": "Archive User"
      }
    },
    "activate": {
      "title": "Activate User",
      "description": "Are you sure you want to activate this user? They will be able to access the system again.",
      "userName": "User: {{name}}",
      "userEmail": "Email: {{email}}",
      "actions": {
        "cancel": "Cancel",
        "activate": "Activate User"
      }
    },
    "options": {
      "gender": {
        "MAN": "Male",
        "WOMAN": "Female",
        "OTHER": "Other"
      },
      "language": {
        "FR": "French",
        "EN": "English"
      },
      "theme": {
        "SYSTEM": "System",
        "LIGHT": "Light",
        "DARK": "Dark"
      },
      "platform": {
        "WEB": "Web",
        "IOS": "iOS",
        "ANDROID": "Android"
      }
    },
    "detail": {
      "back": "Back",
      "loading": "Loading user...",
      "notFound": "User not found",
      "noProfile": "No profile",
      "profileSection": "Profile",
      "impersonate": "View as"
    }
  },
  "impersonation": {
    "banner": "You are acting as {{email}} ({{type}}) — your actions are recorded under your name",
    "quit": "Exit",
    "roles": {
      "institution": "Institution",
      "practitioner": "Practitioner"
    },
    "startFailed": "Failed to start viewing as this user",
    "stopFailed": "Failed to restore your administrator session"
  },
  "success": {
    "userCreated": "User created successfully",
    "userUpdated": "User updated successfully",
    "userArchived": "User archived successfully",
    "userActivated": "User activated successfully"
  },
  "errors": {
    "loadUsersFailed": "Failed to load users",
    "updateUserFailed": "Failed to update user",
    "archiveUserFailed": "Failed to archive user",
    "createUserFailed": "Failed to create user",
    "impersonateFailed": "Failed to start viewing as this user"
  }
}
